import { __assign, __rest } from "tslib";
import React, { lazy, Suspense } from 'react';
import ErrorBoundary from '../../ErrorBoundary';
import retry from '../../utils/webpack/chunkRetry';
import { useIsMounted } from '../../utils/hooks/useIsMounted';
import TierPromotionCard from '../TierPromotionCard';
var TierPromotionCardWithFellaTooltip = lazy(function () {
    return retry(function () {
        return import(
        /* webpackChunkName: "ms_ftue" */
        './TierPromotionCardWithFellaTooltip');
    });
});
export var LoadableTierPromotionCardWithFellaTooltip = function (_a) {
    var isPostsFeedCard = _a.isPostsFeedCard, props = __rest(_a, ["isPostsFeedCard"]);
    var isMounted = useIsMounted();
    var loading = React.createElement(TierPromotionCard, __assign({}, props));
    if (!isMounted) {
        return loading;
    }
    return (React.createElement(ErrorBoundary, { debugComponent: "LoadableTierPromotionCardWithFellaTooltip" },
        React.createElement(Suspense, { fallback: loading },
            React.createElement(TierPromotionCardWithFellaTooltip, __assign({}, props, { isPostsFeedCard: isPostsFeedCard })))));
};
LoadableTierPromotionCardWithFellaTooltip.displayName =
    'LoadableTierPromotionCardWithFellaTooltip';
export default LoadableTierPromotionCardWithFellaTooltip;
//# sourceMappingURL=LoadableTierPromotionCardWithFellaTooltip.js.map